import { createFuncionario, updateFuncionario, deleteFuncionario, fetchFuncionarios, getEmpresaId } from './syncManager.js'
import { supabase } from './supabase.js'

export async function listEmployees({ q = '', status = 'todos' } = {}) {
  const query = q.trim().toLowerCase()
  const all = await fetchFuncionarios()

  return all
    .filter((f) => {
      const fStatus = (f.status || 'ativo').toLowerCase()
      const wanted = (status || 'todos').toLowerCase()
      if (wanted !== 'todos' && fStatus !== wanted) return false
      if (!query) return true
      return (
        (f.nome ?? '').toLowerCase().includes(query) ||
        (f.matricula ?? '').toLowerCase().includes(query)
      )
    })
    .sort((a, b) => (a.nome ?? '').localeCompare(b.nome ?? ''))
}

export async function createEmployee(payload) {
  return createFuncionario({
    id: crypto.randomUUID(),
    nome: (payload.nome ?? '').trim(),
    matricula: (payload.matricula ?? '').trim() || null,
    funcao: (payload.funcao ?? '').trim() || null,
    status: 'ativo'
  })
}

export async function updateEmployee({ id, nome, matricula, funcao, status }) {
  return updateFuncionario(id, {
    nome: (nome ?? '').trim(),
    matricula: (matricula ?? '').trim() || null,
    funcao: (funcao ?? '').trim() || null,
    status: status || 'ativo'
  })
}

export async function deleteEmployee(id) {
  // Verificar se há movimentações pendentes (query direta no banco)
  const { count, error } = await supabase
    .from('movimentacoes')
    .select('id', { count: 'exact', head: true })
    .eq('empresa_id', getEmpresaId())
    .eq('funcionario_id', id)
    .eq('status', 'pendente-devolucao')

  if (error) throw new Error('Erro ao verificar pendências: ' + error.message)
  if (count > 0) {
    throw new Error(`Não é possível excluir. Funcionário possui ${count} empréstimo(s) pendente(s).`)
  }

  return deleteFuncionario(id)
}
